export default __webpack_public_path__ + "static/media/logoMain.e5b90ed1.svg";